import React from 'react';
import './about-contact.scss';

export default () =>
  <div className="contactus">
    <div className="newsletter">
      <div className="contactus__content">
        <div className="contactus__left">
          <h1 className="newsletter__title">
            Contact Us
          </h1>
          <p>
            Have a question or want to get involved?
            <br/>
            We’d love to hear from you!
          </p>
        </div>
        <div className="contactus__right">
          <p>
            <a
              href="mailto:info@thefarmproject.com"
              target="_blank"
            >
              <i className="fas fa-envelope" />
              info@thefarmproject.com
            </a>
          </p>
          <p>
            <a
              href="https://instagram.com/farmproject"
              target="_blank"
            >
              <i className="fab fa-instagram" />
              @farmproject
            </a>
          </p>
          <p>
            <a
              href="https://www.facebook.com/thefarmproject"
              target="_blank"
            >
              <i className="fab fa-facebook" />
              facebook.com/thefarmproject
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>;



// WEBPACK FOOTER //
// ./src/components/about-contact.js